import { Tooltip, Typography, Box } from '@mui/material';
import type { ReactElement } from 'react';

interface FormattedTooltipProps {
  title: string;
  description: string;
  children: ReactElement;
  maxWidth?: number;
}

const FormattedTooltip: React.FC<FormattedTooltipProps> = ({
  title,
  description,
  children,
  maxWidth = 250,
}) => {
  return (
    <Tooltip
      title={
        <Box>
          <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 0.5 }}>
            {title}
          </Typography>
          <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
            {description}
          </Typography>
        </Box>
      }
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: 'white',
            color: 'text.primary',
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: 2,
            maxWidth,
            padding: 1.5,
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default FormattedTooltip;
